import React, {useState} from "react";

import { motion } from "framer-motion";

import TextField from "../../UI/textField";
import TextArea from "../../UI/textArea";
import Button from "../../UI/button";

const DemoRequestForm = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    organization: "",
    about: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
    // Add your form submission logic here
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 100,
      },
    },
  };
  return (
    <div className="">
      <div className="w-[90%] lg:w-[40%] mx-auto bg-white shadow-xl pb-10 border-b-[5px] border-btnColor rounded-md">
        <div className="w-[90%] mx-auto">
          <form onSubmit={handleSubmit}>
              <motion.div className="rounded-md mt-2" variants={itemVariants}>
                <TextField
                  id="fullName"
                  name="fullName"
                  label="Name"
                  value={formData.fullName}
                  onChange={handleChange}
                  fullWidth
                />
              </motion.div>

              {/* Email field */}
              <motion.div variants={itemVariants} className="mt-4">
                <TextField
                  id="email"
                  name="email"
                  label="Email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                  fullWidth
                />
              </motion.div>

              {/* Job Title field */}
              <motion.div variants={itemVariants} className="mt-4">
                <TextField
                  id="phone"
                  name="phone"
                  label="Phone"
                  value={formData.phone}
                  onChange={handleChange}
                  fullWidth
                />
              </motion.div>
              <motion.div variants={itemVariants} className="mt-4">
                <TextField
                  id="organization"
                  name="organization"
                  label="Organization"
                  value={formData.organization}
                  onChange={handleChange}
                  fullWidth
                />
              </motion.div>

            {/* How Can we Help You? field */}
            <motion.div className="mt-4 relative" variants={itemVariants}>
              <TextArea
                id="about"
                 name="about" 
                label="Tell us about your project"
                value={formData.about}
                onChange={handleChange}
                rows={5}
                fullWidth
              />
            </motion.div>

            {/* Submit button */}
            <motion.div
              className="mt-4 flex justify-center "
              variants={itemVariants}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <Button
                variant="contained"
                color="primary"
                size="large"
                onClick={handleSubmit}
                
              >
                Send Message
              </Button>
            </motion.div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default DemoRequestForm;
